<template>
	<div class="main">
		<div class="left">
			<el-image class="compImg" :src="baseImgUrl + compImg"></el-image>
		</div>
		<div class="right">
			<div class="up">{{compIntro}}</div>
			<div class="down">{{compIContact}}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Maritime",
	data() {
		return{
			baseImgUrl: process.env.VUE_APP_IMGURL,
			compImg: '',
			compIntro: '',
			compIContact: ''
		}
	},
	mounted() {
		this.$api.get('about/getMaritime').then(res => {
			this.compImg = res.img;
			this.compIntro = res.introEn;
			this.compIContact = res.contactEn;
		});
	}
}
</script>

<style scoped>
.main{ font-family: 'SiYuan-ExtraLight', sans-serif; }
@media (max-width: 500px){
	.main{ width: 100%; height: fit-content; margin-top: 19px; }
	.left{ width: 100%; animation: fadeInDown; animation-duration: 1.5s;}
	.compImg{ width: 100%; height: 300px; }
	.right{ width: 100%; margin-top: 18px; }
	.up{ animation: fadeInLeft; animation-duration: 1.5s; line-height: 32px; white-space: pre-wrap; }
	.down{ font-size: 14px; animation: fadeInRight; animation-duration: 1.5s; white-space: pre-wrap; margin-top: 18px; }
}
@media (min-width: 500px) and (max-width: 726px){
	.main{ width: 100%; height: fit-content; margin-top: 20px; }
	.left{ width: 100%; animation: fadeInDown; animation-duration: 1.5s;}
	.compImg{ width: 100%; height: 400px; }
	.right{ width: 100%; margin-top: 18px; }
	.up{ animation: fadeInLeft; animation-duration: 1.5s; line-height: 32px; white-space: pre-wrap; }
	.down{ font-size: 14px; animation: fadeInRight; animation-duration: 1.5s; white-space: pre-wrap; margin-top: 18px; }
}
@media (min-width: 726px) and (max-width: 999px){
	.main{ width: 100%; height: fit-content; display: flex; justify-content: space-between; margin-top: 19px; }
	.left{ display: none; }
	.compImg{ width: 100%; height: 300px; }
	.right{ width: 100%; }
	.up{ animation: fadeInRight; animation-duration: 1.5s; line-height: 35px; white-space: pre-wrap; }
	.down{ font-size: 14px; animation: fadeInUp; animation-duration: 1.5s; white-space: pre-wrap; margin-top: 18px; }
}
@media (min-width: 999px) and (max-width: 1251px){
	.main{ width: 100%; height: fit-content; display: flex; justify-content: space-between; margin-top: 22px; }
	.left{ width: 39%; animation: fadeInLeft; animation-duration: 1.5s;  padding-top: 12px; }
	.compImg{ width: 100%; height: 300px; }
	.right{ width: 59%; }
	.up{ animation: fadeInRight; animation-duration: 1.5s; line-height: 35px; white-space: pre-wrap; }
	.down{ font-size: 14px; animation: fadeInUp; animation-duration: 1.5s; white-space: pre-wrap; margin-top: 18px; }
}
@media (min-width: 1252px) and (max-width: 1845px){
	.main{ width: 100%; height: fit-content; display: flex; justify-content: space-between; margin-top: 30px; }
	.left{ width: 39%; animation: fadeInLeft; animation-duration: 1.5s; padding-top: 12px; }
	.compImg{ width: 100%; height: 494px; }
	.right{ width: 59%; }
	.up{ animation: fadeInRight; animation-duration: 1.5s; line-height: 36px; white-space: pre-wrap; }
	.down{ font-size: 14px; animation: fadeInUp; animation-duration: 1.5s; white-space: pre-wrap; margin-top: 18px; }
}
@media (min-width: 1846px) and (max-width: 2200px){
	.main{ width: 100%; height: fit-content; display: flex; justify-content: space-between; margin-top: 30px; }
	.left{ width: 39%; animation: fadeInLeft; animation-duration: 1.5s;  padding-top: 12px; }
	.compImg{ width: 100%; height: 494px; }
	.right{ width: 59%; }
	.up{ animation: fadeInRight; animation-duration: 1.5s; line-height: 36px; white-space: pre-wrap; }
	.down{ font-size: 14px; animation: fadeInUp; animation-duration: 1.5s; white-space: pre-wrap; margin-top: 18px; }
}
@media (min-width: 2201px){
	.main{ width: 100%; height: fit-content; display: flex; justify-content: space-between; margin-top: 30px; }
	.left{ width: 39%; animation: fadeInLeft; animation-duration: 1.5s; padding-top: 12px; }
	.compImg{ width: 100%; height: 494px; }
	.right{ width: 59%; }
	.up{ animation: fadeInRight; animation-duration: 1.5s; line-height: 36px; white-space: pre-wrap; }
	.down{ font-size: 14px; animation: fadeInUp; animation-duration: 1.5s; white-space: pre-wrap; margin-top: 18px; }
}
</style>